/* PTB Atelier — étapes 3 et 4 : texte ou image, police, emplacement, instructions, couleurs de fil (1 à 6) — POUR CHAQUE ARTICLE.
   Deux modes : « même personnalisation pour tous les articles » (on modifie le premier article, les autres suivent) ou
   « chaque article séparément » (onglets, copie possible d'un article à l'autre).
   Contrôles de fichier côté navigateur : format réel (octets d'en-tête), poids, dimensions. Le serveur refait les mêmes contrôles. */
(function () {
  'use strict';
  var C = window.PTB_ATELIER_CFG;
  var A = window.PTBAtelier;
  var root = document.getElementById('ptb-atelier-app');
  if (!C || !A || !root || !A.state || !A.steps || !A.t || !A.preview || !A.fixPlacements) return;

  var T = A.t, S = A.state, esc = A.util.esc, imgUrl = A.util.imgUrl, $ = A.util.$, $$ = A.util.$$;
  var LANG = C.lang;
  var L = C.limits;

  /* ---------- données de configuration : fils et polices ---------- */
  var THREADS = (C.threads || []).map(function (t) {
    return { id: t.id, code: t.code, hex: t.hex, name: { fr: t.name, en: t.nameEn || t.name, ar: t.nameAr || t.name } };
  });
  function threadName(t) { return t.name[LANG] || t.name.fr; }
  function threadById(id) { for (var i = 0; i < THREADS.length; i++) if (THREADS[i].id === id) return THREADS[i]; return null; }
  function fontById(id) { for (var i = 0; i < C.fonts.length; i++) if (C.fonts[i].id === id) return C.fonts[i]; return C.fonts[0]; }
  function threadsOf(d) { return (d.threads || []).map(threadById).filter(Boolean); }
  A.threads = { list: THREADS, name: threadName, byId: threadById, of: threadsOf };
  A.fontById = fontById;

  /* ---------- helpers ---------- */
  function hexLum(h) {
    h = String(h || '#000').replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var n = parseInt(h, 16);
    if (isNaN(n)) return 0;
    return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255;
  }
  function fmtSize(bytes) {
    var kb = LANG === 'fr' ? 'Ko' : 'KB', mb = LANG === 'fr' ? 'Mo' : 'MB';
    if (bytes >= 1048576) return (Math.round(bytes / 104857.6) / 10).toString().replace('.', LANG === 'fr' ? ',' : '.') + ' ' + mb;
    return Math.max(1, Math.round(bytes / 1024)) + ' ' + kb;
  }
  A.util.fmtSize = fmtSize;
  function charLen(s) { return Array.from(s).length; }
  function clip(s, n) { return Array.from(s).slice(0, n).join(''); }

  var UNSUPPORTED = /[^\p{L}\p{M}\p{N} .,'’"“”«»!?&@#%+:;()\/*\-–—]/gu;
  function cleanText(raw) {
    var base = String(raw || '').replace(/[\u0000-\u001f\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069\ufeff]/g, ' ');
    var removed = base.search(UNSUPPORTED) >= 0;
    var s = base.replace(UNSUPPORTED, '').replace(/\s+/g, ' ').replace(/^\s+/, '');
    return { text: clip(s, L.textMax), removed: removed };
  }
  function uid() { return A.util.uid(); }
  function image(d) { return d && d.img ? A.images[d.img] || null : null; }
  /* applique une modification à tous les articles concernés (tous en mode « même », sinon l'article affiché) */
  function setAll(fn) { A.targets().forEach(fn); A.syncSame(); }
  function activeD() { return A.activeLine().d; }

  /* ---------- emplacement / aperçu ---------- */
  A.placementLabel = function (line) {
    var p = A.productByHandle(line.handle);
    var row = A.placementsFor(p ? p.sub : 'other').filter(function (x) { return x[0] === line.d.place; })[0];
    return row ? T(row[1]) : '';
  };
  function garmentHex(line) {
    var det = A.products[line.handle];
    if (!det || !line.color) return '#d9d4c8';
    var c = det.colors.filter(function (x) { return x.value === line.color; })[0];
    return c ? c.hex : '#d9d4c8';
  }
  function pvOpts(line) {
    var p = A.productByHandle(line.handle) || { sub: 'other', cat: 'other', title: line.handle };
    var info = A.lineInfo(line), d = line.d, th = threadsOf(d), garment = garmentHex(line), im = image(d);
    var auto = hexLum(garment) > 0.6 ? '#1b1b1b' : '#f5f1e8';
    return {
      sub: p.sub, cat: p.cat, placement: d.place, garment: garment, type: d.type, text: d.text, font: fontById(d.font),
      thread: th[0] ? th[0].hex : auto, outline: th[1] ? th[1].hex : null, image: im ? im.dataUrl : null,
      emptyLabel: T('step3.emptyPreview'), aria: T('step3.previewTitle') + ' — ' + info.title
    };
  }
  function renderFig(uidv, host) {
    var line = A.lineByUid(uidv), fig = host.querySelector('[data-role="pv-fig"][data-uid="' + String(uidv).replace(/"/g, '') + '"]');
    if (fig && line) A.preview.render(fig, pvOpts(line));
  }
  function renderAllFigs(host) {
    $$('[data-role="pv-fig"]', host).forEach(function (fig) {
      var line = A.lineByUid(fig.getAttribute('data-uid'));
      if (line) A.preview.render(fig, pvOpts(line));
    });
  }
  /* lignes à prévisualiser : une par type d'article en mode « même », sinon l'article affiché */
  function previewRows() {
    if (S.same) return A.groups().map(function (g) { return { key: g.handle, scope: 'handle', line: g.lines[0] }; });
    var l = A.activeLine();
    return l ? [{ key: l.uid, scope: 'line', line: l }] : [];
  }

  /* ---------- résumé d'un article (panneau latéral et récapitulatif) ---------- */
  A.itemDesignHtml = function (info) {
    var d = info.line.d, th = threadsOf(d), im = image(d), what = '';
    if (d.type === 'text' && d.text.trim()) what = '<i>' + esc(T('sum.text')) + '</i> « ' + esc(d.text.trim()) + ' »';
    else if (d.type === 'image' && im) what = '<i>' + esc(T('sum.image')) + '</i> ' + esc(im.name);
    if (!what && !th.length) return '';
    return '<span class="atl-sum__design">' + (what ? '<span>' + what + '</span>' : '') +
      (th.length ? '<span class="atl-dots" aria-label="' + esc(T('sum.threads') + ' : ' + th.map(threadName).join(', ')) + '">' +
        th.map(function (t) { return '<i style="--sw:' + esc(t.hex) + '" title="' + esc(threadName(t)) + '"></i>'; }).join('') + '</span>' : '') + '</span>';
  };

  /* ---------- mode « même personnalisation » / « chaque article » + onglets ---------- */
  function modeBarHtml() {
    var n = S.lines.length;
    if (n < 2) return '';
    return '<div class="atl-mode" role="group" aria-label="' + esc(T('mode.label')) + '">' +
      '<button type="button" class="atl-mode__b' + (S.same ? ' is-on' : '') + '" data-action="mode" data-mode="same" aria-pressed="' + S.same + '"><b>' + esc(T('mode.same')) + '</b><small>' + esc(T('mode.sameHelp', { n: n })) + '</small></button>' +
      '<button type="button" class="atl-mode__b' + (!S.same ? ' is-on' : '') + '" data-action="mode" data-mode="each" aria-pressed="' + (!S.same) + '"><b>' + esc(T('mode.each')) + '</b><small>' + esc(T('mode.eachHelp')) + '</small></button>' +
      '</div><div data-role="mode-confirm" aria-live="polite"></div>';
  }
  function lineDone(line, step) {
    var d = line.d;
    if (step === 4) return d.threads.length >= 1;
    if (!d.type) return false;
    if (d.type === 'text') return !!d.text.trim();
    return !!image(d);
  }
  function tabsHtml(step) {
    if (S.lines.length < 2 || S.same) return '';
    var infos = A.infos();
    var html = '<div class="atl-tabs" role="group" aria-label="' + esc(T('tabs.label')) + '">' + infos.map(function (i, idx) {
      var on = idx === S.tab, done = lineDone(i.line, step);
      var meta = [i.colorLabel, i.sizeLabel].filter(Boolean).join(' · ');
      return '<button type="button" class="atl-tab' + (on ? ' is-on' : '') + (done ? ' is-done' : '') + '" data-action="tab" data-tab="' + idx + '" aria-pressed="' + on + '">' +
        '<img src="' + esc(imgUrl(i.image, 80)) + '" alt="" width="36" height="45" loading="lazy">' +
        '<span class="atl-tab__t"><b>' + esc(T('line.n', { n: i.n })) + (i.qty > 1 ? ' <small>×' + i.qty + '</small>' : '') + '</b><small>' + esc(i.title + (meta ? ' · ' + meta : '')) + '</small></span>' +
        '<span class="atl-tab__s" aria-hidden="true">' + (done ? '✓' : '') + '</span></button>';
    }).join('') + '</div>';
    var act = A.activeLine();
    var others = infos.filter(function (i) { return i.line.uid !== act.uid && (step === 4 ? i.line.d.threads.length : lineDone(i.line, 3)); });
    if (others.length) {
      html += '<label class="atl-copy"><span>' + esc(T(step === 4 ? 'copy.labelThreads' : 'copy.label')) + '</span><select class="input" data-role="copy-from" data-step="' + step + '"><option value="">' + esc(T('copy.choose')) + '</option>' +
        others.map(function (i) { return '<option value="' + esc(i.line.uid) + '">' + esc(A.lineLabel(i)) + '</option>'; }).join('') + '</select></label>';
    }
    return html;
  }
  function rerender() {
    var y = window.pageYOffset;
    A.renderStep({ silent: true });
    window.scrollTo(0, y);
  }

  /* =========================================================
     Étape 3 : texte ou image
     ========================================================= */
  var ICON_TEXT = '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path d="M5 6h14M12 6v13M9 19h6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_IMG = '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><rect x="3.5" y="5" width="17" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="10.5" r="1.7" fill="currentColor"/><path d="M4 17l5-4.5 3.5 3L15 13l5 4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var ICON_UP = '<svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true"><path d="M12 16V5m0 0l-4 4m4-4l4 4M5 19h14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function typeCard(kind) {
    var on = activeD().type === kind;
    return '<label class="atl-type' + (on ? ' is-on' : '') + '"><input type="radio" name="atl-type" value="' + kind + '"' + (on ? ' checked' : '') + '>' +
      '<span class="atl-type__box">' + (kind === 'text' ? ICON_TEXT : ICON_IMG) + '<b>' + esc(T('step3.tab' + (kind === 'text' ? 'Text' : 'Image'))) + '</b><small>' + esc(T(kind === 'text' ? 'step3.typeTextHelp' : 'step3.typeImageHelp')) + '</small></span></label>';
  }
  function fontHtml() {
    var d = activeD();
    return C.fonts.map(function (f) {
      var on = f.id === d.font;
      return '<label class="atl-font' + (on ? ' is-on' : '') + '"><input type="radio" name="atl-font" value="' + esc(f.id) + '"' + (on ? ' checked' : '') + '>' +
        '<span class="atl-font__box"><span class="atl-font__s" style="font-family:\'' + esc(f.family) + '\',Anton,sans-serif" data-role="font-sample">' + esc(d.text.trim() || 'Aa') + '</span><span class="atl-font__n">' + esc(f.label) + '</span></span></label>';
    }).join('');
  }
  function textPanel() {
    var d = activeD();
    return '<div class="atl-field"><label for="atl-text">' + esc(T('step3.textLabel')) + '</label>' +
      '<input id="atl-text" class="input atl-text" type="text" data-role="text" value="' + esc(d.text) + '" maxlength="' + (L.textMax * 2) + '" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="' + esc(T('step3.textPlaceholder')) + '" aria-describedby="atl-text-help atl-text-count">' +
      '<div class="atl-field__row"><p class="atl-help" id="atl-text-help">' + esc(T('step3.textHelp', { max: L.textMax })) + '</p><p class="atl-count" id="atl-text-count" data-role="text-count"></p></div>' +
      '<p class="atl-warn" data-role="text-warn" role="status" hidden>' + esc(T('step3.unsupported')) + '</p></div>' +
      '<fieldset class="atl-fieldset"><legend>' + esc(T('step3.fontLabel')) + '</legend><div class="atl-fonts" data-role="fonts">' + fontHtml() + '</div></fieldset>';
  }
  function imagePanel() {
    return '<div class="atl-field"><span class="atl-label" id="atl-img-l">' + esc(T('step3.imageLabel')) + '</span>' +
      '<div class="atl-drop" data-role="drop">' +
        '<div data-role="drop-empty">' + ICON_UP + '<p class="atl-drop__t">' + esc(T('step3.drop')) + '</p><p class="atl-drop__or">' + esc(T('step3.or')) + '</p>' +
        '<label class="btn btn--outline atl-pick" data-role="pick" tabindex="-1">' + esc(T('step3.pick')) + '<input type="file" class="atl-file" data-role="file" accept="image/png,image/jpeg,.png,.jpg,.jpeg" aria-labelledby="atl-img-l"></label></div>' +
        '<div class="atl-drop__have" data-role="drop-have" hidden>' +
          '<div class="atl-thumb"><img data-role="thumb" alt=""></div>' +
          '<div class="atl-drop__info"><b data-role="img-name"></b><span data-role="img-meta"></span>' +
          '<div class="atl-drop__btns"><button type="button" class="btn btn--outline atl-small" data-action="img-replace">' + esc(T('step3.replace')) + '</button><button type="button" class="atl-link" data-action="img-delete">' + esc(T('step3.delete')) + '</button></div></div>' +
        '</div>' +
        '<p class="atl-drop__busy" data-role="img-busy" hidden>' + esc(T('step3.imageBusy')) + '</p>' +
      '</div>' +
      '<p class="atl-err" data-role="img-err" role="alert"></p>' +
      '<p class="atl-help">' + esc(T('step3.imageRules', { max: L.imageMaxMb, min: L.imageMinPx })) + '</p>' +
      '<p class="atl-help">' + esc(T('step3.imageTips')) + '</p><p class="atl-help">' + esc(T('step3.imageNotProd')) + '</p></div>';
  }
  function placementsHtml() {
    return previewRows().map(function (r) {
      var p = A.productByHandle(r.line.handle), info = A.lineInfo(r.line), title = info.title;
      var opts = A.placementsFor(p ? p.sub : 'other'), cur = r.line.d.place;
      var name = 'atl-pl-' + r.scope + '-' + r.key;
      var radios = opts.length > 1 ? '<fieldset class="atl-fieldset atl-fieldset--tight"><legend>' + esc(T('step3.placementFor', { item: title })) + '</legend><div class="atl-pls">' +
        opts.map(function (o) {
          return '<label class="atl-pl"><input type="radio" name="' + esc(name) + '" data-scope="' + r.scope + '" data-key="' + esc(r.key) + '" value="' + o[0] + '"' + (cur === o[0] ? ' checked' : '') + '><span>' + esc(T(o[1])) + '</span></label>';
        }).join('') + '</div></fieldset>' : '<p class="atl-help"><b>' + esc(title) + '</b> — ' + esc(T(opts[0][1])) + '</p>';
      var meta = [info.colorLabel, info.sizeLabel].filter(Boolean).join(' · ');
      return '<article class="atl-pv"><div class="atl-pv__fig" data-role="pv-fig" data-uid="' + esc(r.line.uid) + '"></div><div class="atl-pv__ctrl"><h5>' + esc(title) + (meta && r.scope === 'line' ? ' <small>' + esc(meta) + '</small>' : '') + '</h5>' + radios + sizeHtml(r) + '</div></article>';
    }).join('');
  }

  /* ---------- taille de la broderie : « carte blanche » ou largeur × hauteur (cm) ----------
     Même portée que l'emplacement : un bloc par type d'article en mode « même personnalisation », sinon par article. */
  var sizeShowErr = false;
  A.imageRatio = function (d) { var im = d && d.type === 'image' ? image(d) : null; return im && im.width && im.height ? im.width / im.height : 0; };
  function sizeLinesOf(box) {
    var scope = box.getAttribute('data-scope'), key = box.getAttribute('data-key');
    return S.lines.filter(function (l) { return (scope === 'handle' && l.handle === key) || (scope === 'line' && l.uid === key); });
  }
  function cleanNum(v) {
    var s = String(v || '').replace(/[٠-٩]/g, function (c) { return String(c.charCodeAt(0) - 1632); }).replace(/٫/g, '.').replace(/[^\d.,]/g, '');
    var m = /^(\d{0,3})([.,](\d{0,2})?)?/.exec(s);
    if (!m) return '';
    return (m[1] || (m[2] ? '0' : '')) + (m[2] ? m[2].charAt(0) + (m[3] || '') : '');
  }
  /* image : les proportions sont conservées (l'autre dimension suit) */
  function syncRatio(l) {
    var ratio = A.imageRatio(l.d), s = A.normSize(l.d.size);
    if (!ratio || s.mode !== 'custom') return;
    var w = A.parseCm(s.w), h = A.parseCm(s.h);
    if (w) s.h = A.fmtCm(w / ratio); else if (h) s.w = A.fmtCm(h * ratio);
    l.d.size = s;
  }
  function sizeHtml(r) {
    var id = 'atl-sz-' + r.scope + '-' + r.key, s = A.normSize(r.line.d.size), custom = s.mode === 'custom', title = A.lineInfo(r.line).title;
    var inp = function (k, label) {
      return '<div class="atl-emb__f"><label for="' + esc(id) + '-' + k + '">' + esc(T('size.' + k)) + '</label>' +
        '<input id="' + esc(id) + '-' + k + '" class="input atl-emb__in" type="text" inputmode="decimal" dir="ltr" autocomplete="off" maxlength="6" data-role="size-' + k + '" value="' + esc(s[k]) + '" aria-describedby="' + esc(id) + '-e"></div>';
    };
    return '<fieldset class="atl-fieldset atl-fieldset--tight atl-emb" data-role="size" data-scope="' + r.scope + '" data-key="' + esc(r.key) + '">' +
      '<legend>' + esc(T('size.legend', { item: title })) + '</legend>' +
      '<div class="atl-pls">' +
        '<label class="atl-pl"><input type="radio" name="' + esc(id) + '" data-role="size-mode" value="auto"' + (custom ? '' : ' checked') + '><span>' + esc(T('size.auto')) + '</span></label>' +
        '<label class="atl-pl"><input type="radio" name="' + esc(id) + '" data-role="size-mode" value="custom"' + (custom ? ' checked' : '') + '><span>' + esc(T('size.custom')) + '</span></label>' +
      '</div>' +
      '<p class="atl-help" data-role="size-help"></p>' +
      '<div class="atl-emb__fields" data-role="size-fields"' + (custom ? '' : ' hidden') + '>' + inp('w') + '<span class="atl-emb__x" aria-hidden="true">×</span>' + inp('h') + '</div>' +
      '<p class="atl-help" data-role="size-note" hidden></p>' +
      '<p class="atl-err" id="' + esc(id) + '-e" data-role="size-err" role="alert"></p></fieldset>';
  }
  function refreshSize(box, showErr) {
    var line = sizeLinesOf(box)[0];
    if (!line) return;
    var d = line.d, s = A.normSize(d.size), st = A.sizeState(d), custom = s.mode === 'custom', ratio = A.imageRatio(d);
    var lim = { min: A.fmtCm(A.sizeLimits.min), max: A.fmtCm(A.sizeLimits.max) };
    var f = $('[data-role="size-fields"]', box); if (f) f.hidden = !custom;
    var w = $('[data-role="size-w"]', box), h = $('[data-role="size-h"]', box);
    if (w && document.activeElement !== w) w.value = s.w;
    if (h && document.activeElement !== h) h.value = s.h;
    var help = $('[data-role="size-help"]', box);
    if (help) help.textContent = !custom ? T('size.helpAuto') : (st.ok ? T('size.sum', { size: A.sizeText(d) }) : T('size.hintCustom', lim));
    var note = $('[data-role="size-note"]', box);
    if (note) { note.hidden = !(custom && ratio); note.textContent = custom && ratio ? T('size.ratio') : ''; }
    var msg = custom && !st.ok && (showErr || box.getAttribute('data-touched') === '1') ? T(st.err === 'range' ? 'size.errRange' : 'size.errBoth', lim) : '';
    var err = $('[data-role="size-err"]', box); if (err) err.textContent = msg;
    [w, h].forEach(function (i) { if (!i) return; if (msg) i.setAttribute('aria-invalid', 'true'); else i.removeAttribute('aria-invalid'); });
  }
  function refreshAllSize(showErr) { $$('[data-role="size"]').forEach(function (b) { refreshSize(b, !!showErr); }); }

  function setImgErr(msg) { var e = $('[data-role="img-err"]'); if (e) e.textContent = msg || ''; }
  function updateImagePanel() {
    var empty = $('[data-role="drop-empty"]'), have = $('[data-role="drop-have"]');
    if (!empty || !have) return;
    var im = image(activeD()), has = !!im;
    empty.hidden = has; have.hidden = !has;
    if (has) {
      $('[data-role="thumb"]').src = im.dataUrl;
      $('[data-role="img-name"]').textContent = im.name;
      $('[data-role="img-meta"]').textContent = T('step3.fileInfo', { name: '', w: im.width, h: im.height, size: fmtSize(im.size) }).replace(/^\s*·\s*/, '');
    }
  }
  function updateTextCount() {
    var c = $('[data-role="text-count"]');
    if (c) c.textContent = T('step3.counter', { n: charLen(activeD().text), max: L.textMax });
  }
  function updateFontSamples() {
    $$('[data-role="font-sample"]').forEach(function (s) { s.textContent = activeD().text.trim() || 'Aa'; });
  }
  function showType() {
    var t = activeD().type;
    var pt = $('[data-role="panel-text"]'), pi = $('[data-role="panel-image"]'), pv = $('[data-role="previews"]');
    if (pt) pt.hidden = t !== 'text';
    if (pi) pi.hidden = t !== 'image';
    if (pv) pv.hidden = !t;
    $$('.atl-type').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').value === t); });
    if (t === 'text') { A.preview.loadFonts(C.fonts).then(function () { var h = $('[data-role="previews"]'); if (h) renderAllFigs(h); }); }
  }

  function scopeHelp() {
    if (S.lines.length < 2) return '';
    return S.same ? T('step3.scopeSame', { n: S.lines.length }) : T('step3.scopeEach', { n: A.lineLabel(A.lineInfo(A.activeLine())) });
  }

  A.steps[3] = {
    render: function (el) {
      A.fixPlacements();
      var d = activeD(), act = A.activeLine();
      el.innerHTML =
        '<header class="atl-step__head"><h3 class="atl-h" id="atl-h3">' + esc(T('step3.title')) + '</h3><p class="atl-sub">' + esc(T(S.lines.length > 1 ? 'step3.subMulti' : 'step3.sub')) + '</p></header>' +
        modeBarHtml() + tabsHtml(3) +
        (S.lines.length > 1 ? '<p class="atl-scope" role="status">' + esc(scopeHelp()) + (act && act.qty > 1 && !S.same ? ' ' + esc(T('step3.qtyNote', { n: act.qty })) : '') + '</p>' : (act && act.qty > 1 ? '<p class="atl-scope" role="status">' + esc(T('step3.qtyNote', { n: act.qty })) + '</p>' : '')) +
        '<div class="atl-types" role="radiogroup" aria-label="' + esc(T('step3.typeLabel')) + '">' + typeCard('text') + typeCard('image') + '</div>' +
        '<div class="atl-panel" data-role="panel-text" hidden>' + textPanel() + '</div>' +
        '<div class="atl-panel" data-role="panel-image" hidden>' + imagePanel() + '</div>' +
        '<section class="atl-previews" data-role="previews" aria-labelledby="atl-pv-h" hidden>' +
          '<h4 id="atl-pv-h">' + esc(T('step3.placementTitle')) + '</h4>' +
          '<p class="atl-help">' + esc(T(S.same && S.lines.length > 1 ? 'step3.sameDesign' : 'step3.oneDesign')) + ' ' + esc(T('step3.sideNote')) + '</p>' +
          '<div class="atl-pvlist">' + placementsHtml() + '</div>' +
          '<p class="atl-note"><span aria-hidden="true">ⓘ</span> ' + esc(T('step3.previewNote')) + '</p>' +
        '</section>' +
        '<div class="atl-field"><label for="atl-instr">' + esc(T('step3.instrLabel')) + ' <small>(' + esc(T('common.optional')) + ')</small></label>' +
        '<textarea id="atl-instr" class="input atl-textarea" data-role="instr" rows="3" maxlength="' + L.instrMax + '" aria-describedby="atl-instr-help">' + esc(d.instr) + '</textarea>' +
        '<p class="atl-help" id="atl-instr-help">' + esc(T('step3.instrHelp')) + '</p></div>';
      updateTextCount(); updateImagePanel(); showType();
      var pvs = $('[data-role="previews"]'); if (pvs) renderAllFigs(pvs);
      refreshAllSize(sizeShowErr); sizeShowErr = false;
    },
    update: function () { },
    validate: function () {
      for (var i = 0; i < S.lines.length; i++) {
        var d = S.lines[i].d, who = S.lines.length > 1 ? ' (' + T('line.n', { n: i + 1 }) + ')' : '';
        if (!d.type) return { ok: false, msg: T('step3.needType') + who, focus: 'input[name="atl-type"]', tab: i };
        if (d.type === 'text' && !d.text.trim()) return { ok: false, msg: T('step3.needText') + who, focus: '[data-role="text"]', tab: i };
        if (d.type === 'image' && !image(d)) return { ok: false, msg: T('step3.needImage') + who, focus: '[data-role="file"]', tab: i };
        var sz = A.sizeState(d);
        if (!sz.ok) {
          var l = S.lines[i], scope = S.same ? 'handle' : 'line', key = S.same ? l.handle : l.uid;
          sizeShowErr = true; refreshAllSize(true);
          return { ok: false, msg: T(sz.err === 'range' ? 'size.errRange' : 'size.errBoth', { min: A.fmtCm(A.sizeLimits.min), max: A.fmtCm(A.sizeLimits.max) }) + who, focus: '[data-role="size"][data-scope="' + scope + '"][data-key="' + String(key).replace(/["\\]/g, '') + '"] [data-role="size-w"]', tab: i };
        }
      }
      return { ok: true };
    }
  };

  /* ---------- fichier image ---------- */
  function readBytes(blob) {
    return new Promise(function (res, rej) {
      var fr = new FileReader();
      fr.onload = function () { res(new Uint8Array(fr.result)); };
      fr.onerror = function () { rej(new Error('read')); };
      fr.readAsArrayBuffer(blob);
    });
  }
  function readDataUrl(file) {
    return new Promise(function (res, rej) {
      var fr = new FileReader();
      fr.onload = function () { res(String(fr.result)); };
      fr.onerror = function () { rej(new Error('read')); };
      fr.readAsDataURL(file);
    });
  }
  function loadImg(url) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { rej(new Error('decode')); };
      im.src = url;
    });
  }
  function isPng(b) { return b.length >= 8 && b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47 && b[4] === 0x0d && b[5] === 0x0a && b[6] === 0x1a && b[7] === 0x0a; }
  function isJpeg(b) { return b.length >= 3 && b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff; }
  /* dimensions lues dans l'en-tête, avant tout décodage (protège contre les images « bombes ») */
  function pngDims(b) {
    if (b.length < 24) return null;
    return { w: ((b[16] << 24) | (b[17] << 16) | (b[18] << 8) | b[19]) >>> 0, h: ((b[20] << 24) | (b[21] << 16) | (b[22] << 8) | b[23]) >>> 0 };
  }
  function jpegDims(b) {
    var i = 2;
    while (i + 9 < b.length) {
      if (b[i] !== 0xff) { i++; continue; }
      var m = b[i + 1];
      if (m === 0xd8 || m === 0x01 || (m >= 0xd0 && m <= 0xd7) || m === 0xff) { i += (m === 0xff ? 1 : 2); continue; }
      var len = (b[i + 2] << 8) | b[i + 3];
      if (m >= 0xc0 && m <= 0xcf && m !== 0xc4 && m !== 0xc8 && m !== 0xcc) return { h: (b[i + 5] << 8) | b[i + 6], w: (b[i + 7] << 8) | b[i + 8] };
      i += 2 + len;
    }
    return null;
  }
  function hasTail(tail, png) {
    var i, s = '';
    if (png) { for (i = Math.max(0, tail.length - 16); i < tail.length; i++) s += String.fromCharCode(tail[i]); return s.indexOf('IEND') >= 0; }
    for (i = Math.max(0, tail.length - 64); i < tail.length - 1; i++) if (tail[i] === 0xff && tail[i + 1] === 0xd9) return true;
    return false;
  }

  /* contrôle complet : retourne une promesse { ok, errKey, vars, image } */
  A.validateImageFile = function (file) {
    var fail = function (k, v) { return Promise.resolve({ ok: false, errKey: k, vars: v || {} }); };
    if (!file) return fail('err.imgCorrupt');
    var name = file.name || 'image', ext = (name.split('.').pop() || '').toLowerCase(), type = (file.type || '').toLowerCase();
    if (type === 'image/svg+xml' || ext === 'svg' || ext === 'svgz') return fail('err.imgSvg');
    var okType = type === 'image/png' || type === 'image/jpeg' || type === 'image/jpg';
    var okExt = ext === 'png' || ext === 'jpg' || ext === 'jpeg';
    if (!(okType || (!type && okExt))) return fail('err.imgType');
    if (!file.size) return fail('err.imgCorrupt');
    var max = L.imageMaxMb * 1048576;
    if (file.size > max) return fail('err.imgSize', { size: fmtSize(file.size), max: fmtSize(max) });
    return Promise.all([readBytes(file.slice(0, 524288)), readBytes(file.slice(Math.max(0, file.size - 64)))]).then(function (parts) {
      var b = parts[0], tail = parts[1];
      var png = isPng(b), jpg = isJpeg(b);
      if (!png && !jpg) return { ok: false, errKey: 'err.imgMismatch', vars: {} };
      if ((type === 'image/png' && !png) || ((type === 'image/jpeg' || type === 'image/jpg') && !jpg)) return { ok: false, errKey: 'err.imgMismatch', vars: {} };
      var dims = png ? pngDims(b) : jpegDims(b);
      if (!dims || !dims.w || !dims.h || !hasTail(tail, png)) return { ok: false, errKey: 'err.imgCorrupt', vars: {} };
      if (Math.max(dims.w, dims.h) > L.imageMaxPx || dims.w * dims.h > 80e6) return { ok: false, errKey: 'err.imgLarge', vars: { max: L.imageMaxPx } };
      if (Math.max(dims.w, dims.h) < L.imageMinPx) return { ok: false, errKey: 'err.imgSmall', vars: { w: dims.w, h: dims.h, min: L.imageMinPx } };
      return readDataUrl(file).then(function (url) {
        return loadImg(url).then(function (im) {
          var w = im.naturalWidth, h = im.naturalHeight;
          if (!w || !h) return { ok: false, errKey: 'err.imgCorrupt', vars: {} };
          var mime = png ? 'image/png' : 'image/jpeg';
          return { ok: true, image: { name: name.replace(/[\u0000-\u001f<>:"\\|?*]/g, '_').slice(0, 120), type: mime, size: file.size, width: w, height: h, dataUrl: url } };
        });
      });
    }).catch(function () { return { ok: false, errKey: 'err.imgCorrupt', vars: {} }; });
  };

  var imgToken = 0;
  function handleFile(file) {
    var token = ++imgToken, busy = $('[data-role="img-busy"]');
    setImgErr('');
    if (busy) busy.hidden = false;
    A.validateImageFile(file).then(function (r) {
      if (token !== imgToken) return;
      if (busy) busy.hidden = true;
      if (!r.ok) { setImgErr(T(r.errKey, r.vars)); return; }
      var id = 'img' + uid();
      A.images[id] = r.image;
      setAll(function (l) { l.d.img = id; l.d.type = 'image'; });
      S.lines.forEach(syncRatio);
      A.gcImages();
      A.setNavError('');
      updateImagePanel(); showType();
      var pvs = $('[data-role="previews"]'); if (pvs) renderAllFigs(pvs);
      refreshAllSize(false);
      A.changed({ skipUpdate: true });
      refreshTabs(3);
    });
  }
  /* image de l'article au format base64 (envoi) */
  A.imageBase64 = function (id) { var im = A.images[id]; return im ? im.dataUrl.replace(/^data:[^,]*,/, '') : ''; };

  /* met à jour les pastilles « terminé » des onglets sans tout redessiner */
  function refreshTabs(step) {
    if (S.same || S.lines.length < 2) return;
    $$('.atl-tab').forEach(function (b, idx) {
      var line = S.lines[idx]; if (!line) return;
      var done = lineDone(line, step);
      b.classList.toggle('is-done', done);
      var s = b.querySelector('.atl-tab__s'); if (s) s.textContent = done ? '✓' : '';
    });
  }

  /* =========================================================
     Étape 4 : couleurs de fil
     ========================================================= */
  function paletteHtml() {
    return THREADS.map(function (t) {
      return '<label class="atl-th" data-id="' + esc(t.id) + '"><input type="checkbox" name="atl-th" value="' + esc(t.id) + '">' +
        '<span class="atl-th__box"><span class="atl-th__dot" style="--sw:' + esc(t.hex) + '"><span class="atl-th__n" data-role="th-n"></span></span>' +
        '<span class="atl-th__name">' + esc(threadName(t)) + '</span><span class="atl-th__code">' + esc(T('step4.code', { code: t.code })) + ' · ' + esc(t.hex.toUpperCase()) + '</span></span></label>';
    }).join('');
  }
  function refreshThreads(msg) {
    var sel = activeD().threads;
    $$('.atl-th').forEach(function (lab) {
      var id = lab.getAttribute('data-id'), i = sel.indexOf(id), input = lab.querySelector('input');
      input.checked = i >= 0;
      lab.classList.toggle('is-on', i >= 0);
      var n = lab.querySelector('[data-role="th-n"]'); if (n) n.textContent = i >= 0 ? String(i + 1) : '';
    });
    var cnt = $('[data-role="th-count"]');
    if (cnt) cnt.textContent = T('step4.count', { n: sel.length, max: L.maxThreads });
    var ul = $('[data-role="chosen"]');
    if (ul) {
      ul.innerHTML = sel.length ? threadsOf(activeD()).map(function (t, i) {
        return '<li><span class="atl-chosen__dot" style="--sw:' + esc(t.hex) + '"></span><b>' + (i + 1) + '</b><span>' + esc(threadName(t)) + ' <small>' + esc(t.code) + '</small></span>' +
          '<button type="button" class="atl-chosen__x" data-action="thread-remove" data-id="' + esc(t.id) + '" aria-label="' + esc(T('step4.removeOne', { name: threadName(t) })) + '">×</button></li>';
      }).join('') : '<li class="atl-muted">' + esc(T('step4.none')) + '</li>';
    }
    var m = $('[data-role="th-msg"]'); if (m) m.textContent = msg || '';
    var pv = $('[data-role="pv4"]'); if (pv) renderAllFigs(pv);
  }
  function previews4() {
    return previewRows().map(function (r) {
      var info = A.lineInfo(r.line), meta = [info.colorLabel, info.sizeLabel].filter(Boolean).join(' · ');
      return '<figure class="atl-pv4"><div class="atl-pv__fig" data-role="pv-fig" data-uid="' + esc(r.line.uid) + '"></div><figcaption>' + esc(info.title + (meta ? ' · ' + meta : '')) + '</figcaption></figure>';
    }).join('');
  }

  A.steps[4] = {
    render: function (el) {
      A.fixPlacements();
      S.lines.forEach(function (l) { l.d.threads = l.d.threads.filter(function (id) { return !!threadById(id); }).slice(0, L.maxThreads); });
      var d = activeD(), act = A.activeLine();
      var isImg = d.type === 'image';
      el.innerHTML =
        '<header class="atl-step__head"><h3 class="atl-h" id="atl-h4">' + esc(T('step4.title')) + '</h3><p class="atl-sub">' + esc(T('step4.sub', { max: L.maxThreads })) + '</p></header>' +
        modeBarHtml() + tabsHtml(4) +
        (S.lines.length > 1 ? '<p class="atl-scope" role="status">' + esc(scopeHelp()) + '</p>' : '') +
        '<div class="atl-th-layout"><div class="atl-th-main">' +
          '<div class="atl-th-head"><h4>' + esc(T('step4.palette')) + '</h4><p class="atl-count" data-role="th-count" aria-live="polite"></p></div>' +
          '<div class="atl-palette" data-role="palette">' + paletteHtml() + '</div>' +
          '<p class="atl-warn" data-role="th-msg" role="status"></p>' +
          '<div class="atl-chosen-wrap"><h4>' + esc(T('step4.selected')) + '</h4><ol class="atl-chosen" data-role="chosen"></ol></div>' +
          '<p class="atl-note"><span aria-hidden="true">ⓘ</span> ' + esc(T(isImg ? 'step4.noteImage' : 'step4.noteText')) + '</p>' +
          '<p class="atl-note"><span aria-hidden="true">ⓘ</span> ' + esc(T('step4.indicative')) + '</p>' +
        '</div><div class="atl-th-side"><h4>' + esc(T('step3.previewTitle')) + '</h4><div class="atl-pv4s" data-role="pv4">' + previews4() + '</div>' +
        '<p class="atl-note"><span aria-hidden="true">ⓘ</span> ' + esc(T('step3.previewNote')) + '</p></div></div>';
      refreshThreads('');
      var fonts = []; S.lines.forEach(function (l) { if (l.d.type === 'text') fonts.push(fontById(l.d.font)); });
      if (fonts.length) A.preview.loadFonts(fonts).then(function () { var p = $('[data-role="pv4"]'); if (p) renderAllFigs(p); });
    },
    update: function () { },
    validate: function () {
      for (var i = 0; i < S.lines.length; i++) {
        var n = S.lines[i].d.threads.length, who = S.lines.length > 1 ? ' (' + T('line.n', { n: i + 1 }) + ')' : '';
        if (n < 1 || n > L.maxThreads) return { ok: false, msg: T('step4.need') + who, focus: 'input[name="atl-th"]', tab: i };
      }
      return { ok: true };
    }
  };

  /* ---------- événements ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-role="size-mode"]')) {
      var sbox = t.closest('[data-role="size"]');
      sizeLinesOf(sbox).forEach(function (l) { var s = A.normSize(l.d.size); s.mode = t.value === 'custom' ? 'custom' : 'auto'; l.d.size = s; syncRatio(l); });
      A.setNavError('');
      refreshSize(sbox, false); A.changed({ skipUpdate: true });
      if (t.value === 'custom') { var wi = $('[data-role="size-w"]', sbox); if (wi) wi.focus({ preventScroll: true }); }
      return;
    }
    if (t.matches('[data-role="size-w"], [data-role="size-h"]')) {
      /* fin de saisie : on met le nombre en forme (virgule ou point selon la langue, une décimale au plus) */
      var nbox = t.closest('[data-role="size"]'), isW = t.matches('[data-role="size-w"]'), nv = A.parseCm(t.value);
      nbox.setAttribute('data-touched', '1');
      if (nv) {
        var txt = A.fmtCm(nv); t.value = txt;
        sizeLinesOf(nbox).forEach(function (l) { var s = A.normSize(l.d.size); if (isW) s.w = txt; else s.h = txt; l.d.size = s; syncRatio(l); });
      }
      refreshSize(nbox, true); A.changed({ skipUpdate: true });
      return;
    }
    if (t.matches('input[name="atl-type"]')) {
      setAll(function (l) { l.d.type = t.value; });
      S.lines.forEach(syncRatio);
      A.setNavError('');
      showType(); var pvs = $('[data-role="previews"]'); if (pvs) renderAllFigs(pvs);
      refreshAllSize(false);
      A.changed({ skipUpdate: true }); refreshTabs(3);
      if (t.value === 'text') { var tx = $('[data-role="text"]'); if (tx) tx.focus({ preventScroll: true }); }
      return;
    }
    if (t.matches('input[name="atl-font"]')) {
      setAll(function (l) { l.d.font = t.value; });
      $$('.atl-font').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
      var f = fontById(t.value);
      A.preview.loadFont(f).then(function () { var p = $('[data-role="previews"]'); if (p) renderAllFigs(p); });
      var p0 = $('[data-role="previews"]'); if (p0) renderAllFigs(p0);
      A.changed({ skipUpdate: true });
      return;
    }
    if (t.matches('input[name^="atl-pl-"]')) {
      var scope = t.getAttribute('data-scope'), key = t.getAttribute('data-key'), changed = [];
      S.lines.forEach(function (l) {
        if ((scope === 'handle' && l.handle === key) || (scope === 'line' && l.uid === key)) { l.d.place = t.value; changed.push(l.uid); }
      });
      var host = $('[data-role="previews"]');
      if (host) { var first = $('[data-role="pv-fig"]', t.closest('.atl-pv')); if (first) renderFig(first.getAttribute('data-uid'), host); }
      A.changed({ skipUpdate: true });
      return;
    }
    if (t.matches('[data-role="file"]')) {
      var file = t.files && t.files[0];
      t.value = '';
      if (file) handleFile(file);
      return;
    }
    if (t.matches('[data-role="copy-from"]')) {
      if (t.value) {
        var from = A.lineByUid(t.value), to = A.activeLine();
        if (from && to) {
          if (t.getAttribute('data-step') === '4') to.d.threads = from.d.threads.slice(0, L.maxThreads);   /* étape « fils » : seuls les fils sont copiés */
          else A.copyDesign(from.uid, to.uid);
        }
        A.gcImages(); A.changed({ skipUpdate: true }); rerender();
      }
      return;
    }
    if (t.matches('input[name="atl-th"]')) {
      var id = t.value, cur = activeD().threads;
      if (t.checked) {
        if (cur.length >= L.maxThreads) { t.checked = false; refreshThreads(T('step4.max', { max: L.maxThreads })); return; }
        if (cur.indexOf(id) < 0) setAll(function (l) { l.d.threads = l.d.threads.concat([id]); });
      } else setAll(function (l) { l.d.threads = l.d.threads.filter(function (x) { return x !== id; }); });
      A.setNavError('');
      refreshThreads('');
      A.changed({ skipUpdate: true }); refreshTabs(4);
    }
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-role="text"]')) {
      var r = cleanText(t.value);
      if (r.text !== t.value) t.value = r.text;
      setAll(function (l) { l.d.text = r.text; });
      var w = $('[data-role="text-warn"]'); if (w) w.hidden = !r.removed;
      if (r.text.trim()) A.setNavError('');
      updateTextCount(); updateFontSamples();
      var pvs = $('[data-role="previews"]'); if (pvs) renderAllFigs(pvs);
      A.changed({ skipUpdate: true }); refreshTabs(3);
    } else if (t.matches('[data-role="instr"]')) {
      var v = t.value.slice(0, L.instrMax);
      setAll(function (l) { l.d.instr = v; });
      A.changed({ skipUpdate: true });
    } else if (t.matches('[data-role="size-w"], [data-role="size-h"]')) {
      var bx = t.closest('[data-role="size"]'), isWidth = t.matches('[data-role="size-w"]'), clean = cleanNum(t.value);
      if (clean !== t.value) t.value = clean;
      sizeLinesOf(bx).forEach(function (l) {
        var s = A.normSize(l.d.size); s.mode = 'custom';
        if (isWidth) s.w = clean; else s.h = clean;
        var ratio = A.imageRatio(l.d), n = A.parseCm(clean);
        if (ratio && n) { if (isWidth) s.h = A.fmtCm(n / ratio); else s.w = A.fmtCm(n * ratio); }
        l.d.size = s;
      });
      A.setNavError('');
      refreshSize(bx, false); A.changed({ skipUpdate: true });
    }
  });

  /* Entrée dans le champ texte = étape suivante */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-role="text"]')) { e.preventDefault(); A.go(4); }
  });

  function applyMode(same) {
    S.same = same;
    if (same) { A.syncSame(); A.gcImages(); }
    A.changed({ skipUpdate: true });
    rerender();
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-action]');
    if (!b || !root.contains(b)) return;
    var act = b.getAttribute('data-action');
    if (act === 'mode') {
      var wantSame = b.getAttribute('data-mode') === 'same';
      if (wantSame === S.same) return;
      if (wantSame && A.designsDiffer()) {
        var box = $('[data-role="mode-confirm"]');
        if (box) box.innerHTML = '<div class="atl-confirm" role="alertdialog" aria-label="' + esc(T('mode.confirmTitle')) + '"><p>' + esc(T('mode.confirm')) + '</p>' +
          '<div class="atl-confirm__btns"><button type="button" class="btn btn--gold atl-small" data-action="mode-confirm">' + esc(T('mode.confirmYes')) + '</button><button type="button" class="btn btn--outline atl-small" data-action="mode-cancel">' + esc(T('common.cancel')) + '</button></div></div>';
        return;
      }
      applyMode(wantSame);
      return;
    }
    if (act === 'mode-confirm') { applyMode(true); return; }
    if (act === 'mode-cancel') { var bx = $('[data-role="mode-confirm"]'); if (bx) bx.innerHTML = ''; return; }
    if (act === 'tab') { S.tab = Math.max(0, parseInt(b.getAttribute('data-tab'), 10) || 0); A.changed({ skipUpdate: true }); rerender(); var tb = $('.atl-tab.is-on'); if (tb) tb.focus({ preventScroll: true }); return; }
    if (act === 'img-replace') { var f = $('[data-role="file"]'); if (f) f.click(); return; }
    if (act === 'img-delete') {
      imgToken++; setImgErr('');
      setAll(function (l) { l.d.img = null; });
      A.gcImages();
      updateImagePanel();
      var pvs = $('[data-role="previews"]'); if (pvs) renderAllFigs(pvs);
      refreshAllSize(false);
      A.changed({ skipUpdate: true }); refreshTabs(3);
      return;
    }
    if (act === 'thread-remove') {
      var id = b.getAttribute('data-id');
      setAll(function (l) { l.d.threads = l.d.threads.filter(function (x) { return x !== id; }); });
      refreshThreads('');
      A.changed({ skipUpdate: true }); refreshTabs(4);
    }
  });

  /* glisser-déposer */
  function dropTarget(e) { return e.target.closest && e.target.closest('[data-role="drop"]'); }
  ['dragenter', 'dragover'].forEach(function (ev) {
    root.addEventListener(ev, function (e) {
      var z = dropTarget(e);
      if (!z) return;
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
      z.classList.add('is-over');
    });
  });
  ['dragleave', 'dragend'].forEach(function (ev) {
    root.addEventListener(ev, function (e) {
      var z = dropTarget(e);
      if (z && !z.contains(e.relatedTarget)) z.classList.remove('is-over');
    });
  });
  root.addEventListener('drop', function (e) {
    var z = dropTarget(e);
    if (!z) return;
    e.preventDefault();
    z.classList.remove('is-over');
    var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) handleFile(file);
  });
})();
